import { createContext } from 'react';
export const ProTableFilterContext = createContext({
    whereCondition: [],
    setWhereCondition: (state) => state,
    fieldMap: {},
});
